module.exports = __webpack_public_path__ + "img/Number=54.a7be5e80.png";